import utils from '@eitje/utils'
import {CheckboxControl, CheckboxHiddenInput, CheckboxRoot} from '~/components/checkbox/components'

/**
 * @typedef {Object} CheckboxProps
 * @property {boolean | 'indeterminate'} [checked] Controlled checked state.
 * @property {(checked: boolean) => void} [onChange] Called with the next checked state.
 * @property {boolean} [disabled] Prevents interaction with the checkbox.
 * @property {string} [className] Additional root classname.
 * @property {import('react').KeyboardEventHandler<HTMLInputElement>} [onKeyDown]
 * @property {import('react').FocusEventHandler<HTMLInputElement>} [onBlur]
 * @property {import('react').MouseEventHandler<HTMLLabelElement>} [onClick]
 */

/** @param {CheckboxProps} props */
export const Checkbox = ({checked, onChange, disabled, className, onKeyDown, onBlur, onClick}) => {
	return (
		<CheckboxRoot
			checked={checked}
			onChange={onChange}
			disabled={disabled}
			className={utils.makeCns('checkbox-root', className)}
			onClick={onClick}
		>
			<CheckboxHiddenInput onKeyDown={onKeyDown} onBlur={onBlur} />
			<CheckboxControl />
		</CheckboxRoot>
	)
}
